module.exports = __webpack_public_path__ + "img/part_header_pc.6e90e52d.jpg";